"use client";

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Logout() {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        await signOut();
        navigate("/login");
      } catch (error) {
        navigate("/login");
      }
    };

    handleLogout();
  }, [navigate, signOut]);

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center p-4">
      <div className="text-center">
        <h2 className="text-2xl font-bold">Abmeldung läuft...</h2>
        <p className="text-sm text-muted-foreground">
          Bitte warte, während wir dich abmelden.
        </p>
      </div>
    </div>
  );
}
